import { externalLinks } from '@/constants/externalLinks.ts';
import usePersistentPreferencesStore from '@/store/usePersistentPreferencesStore.ts';
import { clearReturnPathFromStorage, getReturnPathFromStorage } from '@/utils/returnPathStorage.ts';

interface AuthRedirectData {
	redirectUrl?: string | null;
}

const clearPendingReturnPath = () => {
	usePersistentPreferencesStore.getState().clearReturnPath();
	clearReturnPathFromStorage();
};

const navigateTo = (url: string, replace: boolean) => {
	if (replace) {
		window.location.replace(url);
		return;
	}

	window.location.href = url;
};

export const redirectToBackendAuthTarget = (
	redirectUrl?: string | null,
	options: { replace?: boolean } = {},
): boolean => {
	if (redirectUrl) {
		clearPendingReturnPath();
		navigateTo(redirectUrl, !!options.replace);
		return true;
	}

	return false;
};

export const redirectToPendingReturnPath = (options: { replace?: boolean } = {}): boolean => {
	const returnPath = getReturnPathFromStorage();

	if (returnPath) {
		clearPendingReturnPath();
		navigateTo(returnPath, !!options.replace);
		return true;
	}

	return false;
};

export const redirectToPendingAuthTarget = (
	redirectUrl?: string | null,
	options: { replace?: boolean } = {},
): boolean => {
	if (redirectToBackendAuthTarget(redirectUrl, options)) {
		return true;
	}

	return redirectToPendingReturnPath(options);
};

export const routeAfterAuth = (
	data?: AuthRedirectData | null,
	fallbackPath: string = externalLinks.spotnana.book,
): void => {
	if (redirectToPendingAuthTarget(data?.redirectUrl)) {
		return;
	}

	window.location.href = fallbackPath;
};
